<template>

    <div>
        <v-app id="inspire">
            <v-layout row justify-center>
                <v-dialog v-model="onShow" persistent max-width="40%">
                    <v-card>
                        <v-card-title>
                            <span class="subheading">MARS - User Administration: {{user.userName}}</span>
                        </v-card-title>

                        <v-divider></v-divider>


                        <v-container grid-list-xs style="margin-top: -20px" fill-height>
                            <v-layout wrap align-center>
                                <v-flex class="modal-flex-height" xs12 sm5>
                                    <v-subheader>Username</v-subheader>
                                </v-flex>

                                <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                    <v-text-field
                                            id="modify_user_user_name_field"
                                            name="userName"
                                            v-model="user.userName"
                                            color="grey darken-2"
                                            :disabled="disabled"
                                            class="text-xs-left"
                                            v-validate="'required:true'"
                                            :error-messages="errors.first('userName')"
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height">
                                    <v-subheader>Firstname</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8 md7 class="modal-flex-height compact-form">
                                    <v-text-field
                                            id="modify_user_first_name_field"
                                            name="firstName"
                                            v-model="user.firstName"
                                            color="grey darken-2"
                                            :disabled="disabled"
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height">
                                    <v-subheader>Lastname</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8 md7 class="modal-flex-height compact-form">
                                    <v-text-field
                                            id="modify_user_last_name_field"
                                            name="lastName"
                                            v-model="user.lastName"
                                            color="grey darken-2"
                                            :disabled="disabled"
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height">
                                    <v-subheader>Email</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8 md7 class="modal-flex-height compact-form">
                                    <v-text-field
                                            id="modify_user_email_field"
                                            name="email"
                                            v-model="user.email"
                                            color="grey darken-2"
                                            :disabled="disabled"
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height">
                                    <v-subheader>Is active?</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8 md7 class="modal-flex-height compact-form">
                                    <v-checkbox
                                            id="modify_user_is_active_checkbox"
                                            name="isActive"
                                            v-model="user.isActive"
                                            color="grey darken-2"
                                            :disabled="disabled"
                                            small
                                    ></v-checkbox>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height">
                                    <v-subheader>Password</v-subheader>
                                </v-flex>
                                <v-flex xs4 sm4 md5 class="modal-flex-height compact-form">
                                    <v-text-field
                                            id="modify_user_password_field"
                                            name="password"
                                            v-model="user.password"
                                            color="grey darken-2"
                                            :readonly="!showField('password')"
                                            :append-icon="show ? 'visibility' : 'visibility_off'"
                                            :type="show ? 'text' : 'password'" @click:append="show = !show"
                                            ref="password"
                                            v-validate.immediate="'required_if:createUserMode,true'"
                                            :error-messages="errors.first('password')"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex x1 sm1 md1 class="modal-flex-height"
                                        v-if="!showField('password')" style="text-align: initial;">

                                    <v-btn id="modify_user_edit_password_button" flat icon small
                                           @click="focusField('password')">
                                        <v-icon dark>edit</v-icon>
                                    </v-btn>
                                </v-flex>


                                <v-flex v-else xs1 sm1 md1>
                                    <v-btn id="modify_user_confirm_password_change_button" flat icon small
                                           color="success" @click="blurField()">
                                        <v-icon>check_circle</v-icon>
                                    </v-btn>
                                </v-flex>


                                <v-flex xs6 sm4 md5 class="modal-flex-height" v-if="showField('password')">
                                    <v-subheader>Password repeat</v-subheader>
                                </v-flex>
                                <v-flex xs4 sm4 md5 class="modal-flex-height compact-form" v-if="showField('password')">
                                    <v-text-field
                                            id="modify_user_password_repeat_field"
                                            name="passwordRepeat"
                                            v-model="user.passwordRepeat"
                                            color="grey darken-2"
                                            :disabled="!showField('password')"
                                            v-validate="'required|confirmed:password'"
                                            :error-messages="errors.first('passwordRepeat')"
                                            :append-icon="show ? 'visibility' : 'visibility_off'"
                                            :type="show ? 'text' : 'password'" @click:append="show = !show"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs1 sm1 md1 v-if="showField('password')">
                                    <v-btn id="modify_user_cancel_password_button" flat icon small
                                           @click="cancelField()">
                                        <v-icon dark>remove_circle</v-icon>
                                    </v-btn>
                                </v-flex>


                                <!-- this checkbox is only a helper to validate that the password is only in creation mode required-->
                                <v-checkbox ref="createUserMode" name="createUserMode" v-model="createUser"
                                            v-show="false"></v-checkbox>


                            </v-layout>
                        </v-container>


                        <v-alert :value="error" type="error" transition="scale-transition">
                            {{ errorMessage }}
                        </v-alert>


                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn id="modify_user_save_button" class="text-none" color="green" small dark
                                   @click="onSaveUser"
                                   :disabled="disabled">Save
                            </v-btn>
                            <v-btn id="modify_user_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-app>
    </div>

</template>

<script>

    import userinterface from "../../../../interfaces/userinterface";
    import {EventBus} from "../../../../eventbus";
    import errormessagemanager from "../../../../managers/errormessagemanager";

    export default {
        name: 'ShowUserModal',

        props: {
            value: Boolean,

            editMode: Boolean,
            createUser: Boolean,

            user: {
                userId: Number,
                userName: String,
                firstName: String,
                lastName: String,
                password: String,
                passwordRepeat: String,
                passwordHash: String,
                email: String,
                isActive: Boolean,
                selectedRoles: Array
            }
        },

        data: () => ({
            editField: '',
            error: false,
            errorMessage: null,

            show: false,
        }),

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },


            getTitle: function () {
                return this.createUser ? "Create" : "Edit";
            },

            disabled: function () {
                return !this.editMode || this.showField('password');
            },
        },

        methods: {

            async onSaveUser() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (this.createUser) {
                            await userinterface.postUser(this.user, res => {
                                response = res;
                            });
                        } else {
                            await userinterface.putUser(this.user, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('userModalClosed');
                            this.close();
                        }
                    }
                });
            },

            focusField(name) {
                this.editField = name;
            },

            blurField() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.editField = '';
                    }
                })

            },

            cancelField() {
                this.editField = '';
            },

            showField(name) {
                return this.editField === name;
            },

            async close() {
                await EventBus.$emit('userDialogClosed');

                this.onShow = false;

                this.clearData();
                this.clearAlert();
                this.cancelField();
            },

            clearData() {
                this.user.userId = null;
                this.user.userName = null;
                this.user.firstName = null;
                this.user.lastName = null;
                this.user.password = null;
                this.user.passwordRepeat = null;
                this.user.passwordHash = null;
                this.user.email = null;
                this.user.isActive = false;

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    };
</script>

<style>
    .user-modal-table {
        text-align: left;
        vertical-align: baseline;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/users/modals/ShowUserModal.vue